import { render, staticRenderFns } from "./ShopifyMenu.vue?vue&type=template&id=800a965a&scoped=true"
import script from "./ShopifyMenu.vue?vue&type=script&lang=js"
export * from "./ShopifyMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800a965a",
  null
  
)

export default component.exports